import Feature from "../../../../../js/stores/user/Feature";
import hasFeature from "../../../../../js/stores/user/actions/hasFeature";

export const isRegionValid = (region: string) => {
  // Region is not required for UK users so return true
  if (!hasFeature(Feature.usAccess)) return true;

  return region.length > 0;
};
